import { FC } from 'react';
import { getBookingStyles } from './BookingStyles';
import { CompanyInfo, UserInfo } from './BookingTypes';
import { Check } from 'lucide-react';

interface BookingSuccessProps {
    selectedDate: string;
    selectedTime: string;
    company?: CompanyInfo;
    user?: UserInfo;
}

const BookingSuccess: FC<BookingSuccessProps> = ({ selectedDate, selectedTime, company, user }) => {
    const primaryColor = company?.brandColors?.primary || '#4F46E5';

    return (
        <div className="status-screen">
            <style>{getBookingStyles()}</style>
            <div className="portal-message-card success-entry">
                {company?.logoUrl && (
                    <img
                        src={company.logoUrl}
                        alt={company.name}
                        className="company-logo-success"
                        style={{ maxHeight: '40px', marginBottom: '24px' }}
                    />
                )}

                <div className="success-icon-wrapper" style={{ backgroundColor: '#DEF7EC', color: '#03543F' }}>
                    <Check size={32} strokeWidth={3} />
                </div>

                <h1>Meeting Confirmed</h1>
                <p className="subtitle">You are scheduled with <strong>{user?.name || 'Our Team'}</strong></p>

                <div className="confirmation-meta">
                    <div className="meta-row">
                        <span className="label">Date</span>
                        <span className="value">{new Date(selectedDate).toLocaleDateString(undefined, { month: 'long', day: 'numeric', year: 'numeric' })}</span>
                    </div>
                    <div className="meta-row">
                        <span className="label">Time</span>
                        <span className="value">{new Date(selectedTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                    </div>
                </div>

                <div className="success-notice">
                    <p>A calendar invitation has been sent to your email address. Please accept it to add the meeting to your calendar.</p>
                </div>

                <button
                    onClick={() => window.close()}
                    className="solid-btn"
                    style={{ backgroundColor: primaryColor }}
                >
                    Done
                </button>
            </div>
        </div>
    );
};

export default BookingSuccess;
